<template>
  <el-dialog
    class="radish-dia"
    title="请选择项目"
    top="70px"
    :modal="false"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <div>
      <el-alert title="可以根据项目编号来搜索" type="warning"> </el-alert>
      <el-select v-model="pid" class="full-width" size="mini" filterable>
        <el-option v-for="(op, k) in proOptions" :key="k" :label="op.label" :value="op.value"></el-option>
      </el-select>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="mini" @click="dialogVisible = false">取 消</el-button>
      <el-button :disabled="!pid" size="mini" type="primary" @click="confirm">确定</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  props: {
    handleConfirm: { type: Function, default: () => {} },
    type: { type: String, default: '' }, // onlyIn
  },
  data: function() {
    return {
      dialogVisible: false,
      proOptions: [],
      pid: '',
      rid: '',
    }
  },
  methods: {
    show: function(rid) {
      this.pid = ''
      this.rid = rid
      this.loadPro()
      this.dialogVisible = true
    },
    loadPro: async function() {
      const pros = await app.service('project').simpleProjects()
      if (pros.status === 200) {
        let proData = pros.data
        if (proData && proData.length > 0) {
          if (this.rid) {
            const inPros = await app.service('radish').findProjectByRid({ rid: this.rid })
            if (inPros.status == 'success') {
              const inData = inPros.data
              const inIds = inData.map(p => p.pid)
              proData = proData.filter(p => {
                if (inIds.includes(p._id)) {
                  return false
                }
                return true
              })
              proData = inData.concat(proData)
            } else {
              console.error(inPros.msg)
            }
            if (this.type == 'onlyIn') {
              proData = proData.filter(p => p.人选进展阶段)
            }
          }
          this.proOptions = proData.map(item => {
            let label = `${item['项目名称']}(${item['客户公司']})(${item.编号})`
            if (item.人选进展阶段) {
              label += `(${item.人选进展阶段})`
            }
            return { label: label, value: item.pid || item._id }
          })
        }
      } else {
        console.error(pros.message)
      }
    },
    confirm: function() {
      if (!this.pid) return this.$message.info('请选择项目')
      if (this.handleConfirm) {
        this.dialogVisible = false
        return this.handleConfirm({ pid: this.pid })
      }
    },
  },
}
</script>
<style>
.radish-dia > .el-dialog > .el-dialog__body {
  padding: 0 20px;
}
.radish-dia-search {
  padding: 5px 0;
}
</style>
